//sub menu items
$(window).on("load resize ",function(e){
    if($(window).innerWidth() <= 1254) {
        $( ".has-child-link" ).click(function() {
            $('.child-links').toggleClass( "active" );
        });
    } else {

    }
});

//mobile menu

$( ".menu-toggle" ).click(function() {
    $('body').toggleClass("menu-active");
    $( this ).toggleClass( "active" );
    $('.main-nav').toggleClass("active");
  	if( !$('.main-nav .doubly-float').length ) {
      $('.doubly-float').clone().appendTo("ul.main-nav");
    }
});

$('#tabs').responsiveTabs({
    startCollapsed: 'accordion'
});

//address toggles

$("#addNewToggle").click(function() {
    $('.new-address-form').removeClass( "hide" );
});

$(".editToggle").click(function() {
    $(this).closest('div').find('.hide').removeClass("hide" );
    $(this).closest('.container-small').addClass('min-height');
});

$("#addNewToggle").click(function() {
   $(this).closest('div').find('.hide').removeClass("hide" );
   $(this).closest('.container-small').addClass('min-height');
});

$("#cancelNewToggle").click(function() {
   $('.new-address-form').addClass("hide" );
   $(this).closest('.container-small').removeClass('min-height');
});

$(".cancelToggle").click(function() {
    $('.edit-address').addClass("hide" );
  	$(this).parent('form')[0].reset();
    $(this).closest('.container-small').removeClass('min-height');
});
